import { Injectable } from '@angular/core';
import { AbstractStore } from './store';
import { UserLinkRecord } from 'src/app/model/user-link';

@Injectable({
  providedIn: 'root',
})
export class UserLinksStore extends AbstractStore<UserLinkRecord> {}
